import React, { useEffect, useRef } from "react";
import { CostumeSet } from "../../lib/costumes/Costume";
import { AnimationManager } from "../../lib/graphics/AnimationManager";
import CostumeRenderer from "../../lib/costumes/CostumeRenderer";
import "./CostumeCanvas.scoped.scss";
import CostumeCompositor from "../../lib/costumes/CostumeCompositor";

interface Props {
  costumeCompositor: CostumeCompositor;
  costumes: CostumeSet;
}

export default function CostumeCanvas(props: Props) {
  const refCanvas = useRef<HTMLCanvasElement>(null);
  const animationManager = useRef<AnimationManager>(new AnimationManager());
  const costumeRenderer = useRef<CostumeRenderer | null>(null);

  useEffect(() => {
    if (!refCanvas.current) {
      throw new Error("Canvas reference error");
    }

    // Initialize costume renderer
    if (costumeRenderer.current === null) {
      costumeRenderer.current = new CostumeRenderer(
        refCanvas.current,
        props.costumeCompositor,
        props.costumes
      );
      animationManager.current.frame = costumeRenderer.current;
    }

    // Syncronize costumes
    if (costumeRenderer.current !== null) {
      costumeRenderer.current.updateCostumes(props.costumes);
    }

    // Start rendering
    animationManager.current.run();

    return () => {
      // Stop rendering
      // eslint-disable-next-line react-hooks/exhaustive-deps
      animationManager.current.stop();
    };
  }, [props.costumeCompositor, props.costumes]);

  return (
    <div className="canvas-container">
      <canvas ref={refCanvas} width="630" height="630"></canvas>
    </div>
  );
}
